import { useMemo } from 'react';
import { defineSchemaSource } from '../types/SchemaSource';
import type { SchemaSource, SchemaSourceInput } from '../types/SchemaSource';

/** Hook form of `defineSchemaSource` */
export function useSchemaSource<T>(
  input: SchemaSourceInput<T>,
): SchemaSource<T> {
  return useMemo(() => defineSchemaSource(input), [input.collectionId]);
}
